module.exports = __webpack_public_path__ + "static/img/7.08c16e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/7.png
// module id = R/az
// module chunks = 2